/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, value: { price: 0 } },
  { id: 1, value: { price: 0 } },
  { id: 2, value: { price: 0 } },
  { id: 3, value: { price: 0 } },
  { id: 4, value: { price: 0 } },
  { id: 5, value: { price: 0 } },
  { id: 6, value: { price: 0 } },
  { id: 7, value: { price: 0 } },
  { id: 8, value: { price: 0 } },
  { id: 9, value: { price: 0 } },
  { id: 10, value: { price: 0 } },
  { id: 11, value: { price: 0 } },
  { id: 12, value: { price: 20 } },
  { id: 13, value: { price: 0 } },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>STT</Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Số tiền</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {
                  "Doanh thu của hoạt động bán toàn bộ doanh nghiệp có gắn với chuyển nhượng bất động sản"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[13]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={0}
                  name="price"
                  value={data[0].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {
                  "Chi phí của hoạt động bán toàn bộ doanh nghiệp có gắn với chuyển nhượng bất động sản"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"[14]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={1}
                  name="price"
                  readonly="true"
                  value={data[1].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              >
                {"Trong đó"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "#ddeff3",
                }}
              ></Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"Giá vốn của đất chuyển nhượng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                {"[15]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  fontWeight: 400,
                  background: "transparent",
                }}
              >
                <InputTable
                  id={3}
                  name="price"
                  value={data[3].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Chi phí đền bù thiệt hại về đất"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[16]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={4}
                  name="price"
                  value={data[4].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Chi phí đền bù thiệt hại về hoa màu"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[17]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={5}
                  name="price"
                  value={data[5].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Chi phí cải tạo san lấp mặt bằng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[18]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={6}
                  name="price"
                  value={data[6].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={7}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Chi phí đầu tư xây dựng kết cấu hạ tầng"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[19]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={7}
                  name="price"
                  value={data[7].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={8}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              ></Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Chi phí khác (bao gồm cả giá mua của phần vốn chuyển nhượng)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"[20]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={8}
                  name="price"
                  value={data[8].value.price}
                  onChange={handleChange}
                />
              </Td>
            </tr>
            <tr key={9}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"3"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {
                  "Thu nhập từ hoạt động bán toàn bộ doanh nghiệp có gắn với chuyển nhượng bất động sản ([21]=[13]-[14])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[21]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={9}
                  name="price"
                  readonly="true"
                  value={data[9].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={10}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"4"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Số lỗ từ hoạt động chuyển nhượng bất động sản được chuyển kỳ này"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[22]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={10}
                  name="price"
                  readonly="true"
                  value={data[10].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={11}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"5"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {
                  "Thu nhập tính thuế thu nhập doanh nghiệp (TNDN) từ hoạt động bán toàn bộ doanh nghiệp có gắn với chuyển nhượng bất động sản ([23]=[21]-[22])"
                }
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[23]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={11}
                  name="price"
                  readonly="true"
                  value={data[11].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={12}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"6"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Thuế suất thuế (TNDN) (%)"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[24]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={12}
                  name="price"
                  readonly="true"
                  value={data[12].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={13}>
              <Td
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"7"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"Thuế TNDN phải nộp ([25]=[23]x[24])"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: 400,
                }}
              >
                {"[25]"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={13}
                  name="price"
                  readonly="true"
                  value={data[13].value.price}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
